import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachedruidComponent } from './simple-icons-apachedruid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachedruidComponent ],
    exports:      [ SimpleIconsApachedruidComponent ],
    bootstrap:    []
})
export class SimpleIconsApachedruidModule {}
